import fetch from '@/utils/fetch';

export interface CityListResult {
  value: string;
  label: string;
  children?: CityListResult[];
}

/**
 * 获取省市区公共接口
 * @returns
 */
export const getCityList = () => fetch<CityListResult[]>('/saasmerchant/getAllAddress');
